var messageCache = {};
export function warnOnce(component, message) {
    var warning = "[AwsUi] [" + component + "] " + message;
    if (!messageCache[warning]) {
        messageCache[warning] = true;
        console.warn(warning);
    }
}
